class duplicateMessageController {
  /*@ngInject*/
  constructor(Auth, $state, $stateParams, User, MessageService, $translate, Modal) {

    this.hasAcl = {};
    this.Auth = Auth;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.User = User;
    this.MessageService = MessageService;
    this.$translate = $translate;
    this.page = 1;
    this.total = 0;
    this.pageLimit = 10;
    this.maxPages = 10;
    this.searchText = null;
    this.loggedInUser = this.User.getUser();
    this.Modal = Modal;
    this.messages = [];
    this.duplicateMsgs = [];
    this.pendingMegs = []
    this.branchId = this.User.getUser().branchId;

    this.types = ['M', 'T', 'R', 'SM', 'NP', 'UI', 'H', 'D_R', 'CNT', 'D_CNT', 'NDR', 'IM', 'DS'];
    this.messageType = null;
    this.messageTypes = this.types.map((messageType) => {
      return {
        value: messageType,
        label: $translate.instant('message.types.' + messageType)
      };
    });

    this.model = {
      languageList: {
        english: 'E',
        spanish: 'S'
      },
      stats: 'E'
    }
    this.model.selectedLanguage = this.loggedInUser.languageId === "E" ? this.model.languageList.english : this.model.languageList.spanish;
    this.stats = {
      english: 'E',
      spanish: 'S'
    }
  }

  $onInit() {
    this.loadData();
  }

  loadData() {
    this.duplicateMsgList();
  }

  duplicateMsgList() {
    this.loading = true;
    this.MessageService.getDuplicateMsg(this.model.selectedLanguage, this.searchText, this.messageType, (this.page - 1) * this.pageLimit, this.pageLimit)
      .then((data) => {
        this.duplicateMsgs = data.results;
        this.totalDuplicateRecords = data.total;
      })
      .catch((err) => {
        this.error = err.data.message;
      })
      .finally(() => {
        this.loading = false;
      })
  }

  refresh() {
    this.duplicateMsgList();
  }

  tabSelection(selectedValue) {
    this.model.stats = selectedValue;
    this.model.selectedLanguage = selectedValue;
    const id = (selectedValue === 'english') ? 'english' : 'spanish';
    document.getElementById(id).blur();
    this.loadData();
  }

  updateLanguageMessageModal(messagesObj) {
    this.Modal.translateMessage(messagesObj.messageId, messagesObj.type, ({ updatedMessages, modal }) => {
      this.MessageService.updateLanguageMessage(this.model.selectedLanguage, updatedMessages)
        .then(() => {
          this.page = 1;
          this.refresh();
          modal.close();
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            errorModal(err.data.message);
          }
        })
      modal.close();
    }, ({ modal }) => {
      if (modal) modal.close();
    })
  }

  translateMessageType(messageType) {
    if (!messageType) return;
    return this.$translate.instant(`message.types.${messageType}`);
  }

  search() {
    this.page = 1;
    this.duplicateMsgList();
  }

}

export default duplicateMessageController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/message/duplicate_message/duplicate_message.controller.js